
const sellerTabs= {
    namespaced:true,
    state:{
        tabSelected:{
            tabIndex:null,
            type:'',
        }
    },
    actions:{
        selectTab({commit},payload){
            commit('SELECT_TAB', payload)
        },
        selectTabIndex({commit}, payload){
            commit('SELECT_TAB_INDEX', payload)
        }
    },
    mutations:{
        SELECT_TAB:(state, payload)=>{
            state.tabSelected = payload;
        },
        SELECT_TAB_INDEX:(state, payload)=>{
            state.tabSelected.tabIndex = payload;
        }
    },
    getters:{
        getTabSelected(state){
            return state.tabSelected
        }
    }
}


export default sellerTabs